<template>
  <b-modal
    :id="modalId"
    modal-class="p-4 big-modal"
    dialog-class="modal-lg"
    content-class="text-center pb-2"
    no-close-on-esc
    no-close-on-backdrop
    hide-header
    hide-footer
    lazy
  >
    <div class="gigawhat-modal ml-3 mb-2 ">
      <div class="modal-heading mt-3 ">
        <h2 class="modal-title">
          Remplacer le document -
          <span v-if="Array.isArray(selectedDocument.types)">
            {{ selectedDocument.types[0].name }}
          </span>
          <span v-else>{{ selectedDocument.types.name }}</span>
        </h2>
      </div>
      <div class="giga-files_upload">
        <span class="fs-6"> <strong>Document actuel</strong></span>
        <div class="giga-files_upload_section">
          <div class="giga-files_upload_header">
            <div class="giga-files_header_col_name">
              <h3 class="giga-files_upload_title">
                Nom du document
              </h3>
            </div>
            <div class="giga-files_header_col_type">
              <h3 class="giga-files_upload_title">
                Type
              </h3>
            </div>
            <div class="giga-files_header_col_date">
              <h3 class="giga-files_upload_title">
                Date de transmission
              </h3>
            </div>
          </div>
          <div class="giga-upload_files_list">
            <div class="giga-upload_file_item">
              <div class="giga-upload_file_name">
                <i class="extention-icon">
                  <img
                    v-if="getFileExtention(selectedDocument.name) === 'xlsx'"
                    alt="xls.svg"
                    src="~@/assets/images/extensions/xls.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(selectedDocument.name) === 'txt'
                    "
                    alt="txt.svg"
                    src="~@/assets/images/extensions/txt.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(selectedDocument.name) === 'pdf'
                    "
                    alt="pdf.svg"
                    src="~@/assets/images/extensions/pdf.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(selectedDocument.name) === 'docx'
                    "
                    alt="doc.svg"
                    src="~@/assets/images/extensions/doc.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(selectedDocument.name) === 'doc'
                    "
                    alt="doc.svg"
                    src="~@/assets/images/extensions/doc.svg"
                  />
                  <img
                    v-else
                    alt="text.svg"
                    src="~@/assets/images/extensions/text.svg"
                  />
                </i>
                {{ selectedDocument.name }}
              </div>
              <div class="giga-upload_file_type">
                <span v-if="Array.isArray(selectedDocument.types)">
                  {{ selectedDocument.types.map(type => type.name).join(", ") }}
                </span>
                <span v-else>
                  {{ selectedDocument.types.name }}
                </span>
              </div>
              <div class="giga-upload_file_date">
                <span v-if="selectedDocument.creationDate"
                  >{{
                    moment(selectedDocument.creationDate, "x").format(
                      "DD/MM/YYYY"
                    )
                  }}
                </span>
                <span v-else>{{ new Date().toLocaleDateString("fr-FR") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center mt-2 mb-2 h-75">
        <svg
          width="80"
          height="70"
          viewBox="0 0 35 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.638 7.106 17.532 5H9.106A2.106 2.106 0 0 0 7 7.106v12.639a2.107 2.107 0 0 0 2.106 2.106h7.373v2.106l4.212-3.16-4.212-3.159v2.106H9.106V7.106h10.532zm7.372 7.373v11.585a2.107 2.107 0 0 1-2.106 2.106H13.32a2.106 2.106 0 0 1-2.106-2.106v-2.107h2.106v2.107h11.585v-9.479h-5.266v-5.266H13.32v6.32h-2.106v-6.32a2.106 2.106 0 0 1 2.106-2.106h8.425l5.267 5.266z"
            fill="#9AADBE"
          />
        </svg>
      </div>

      <div class="giga-files_upload" v-if="files.length">
        <span class="fs-6"><strong>Document remplacer</strong></span>
        <div class="giga-files_upload_section bg-white">
          <div class="giga-files_upload_header">
            <div class="giga-files_header_col_action"></div>
            <div class="giga-files_header_col_name">
              <h3 class="giga-files_upload_title">
                Nom du document
              </h3>
            </div>
            <div class="giga-files_header_col_type_replace">
              <h3 class="giga-files_upload_title">
                Type
              </h3>
            </div>
            <div class="giga-files_header_col_date">
              <h3 class="giga-files_upload_title">
                Date de transmission
              </h3>
            </div>
          </div>
          <div
            v-if="documentUpload && documentUpload.nomDuDocument"
            class="giga-upload_files_list"
          >
            <div class="giga-upload_file_item">
              <div class="giga-upload_file_action">
                <button class="upload_file_delete_action" @click="clearFile()">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.256 8L15.52 2.736C15.824 2.448 16 2.048 16 1.6C16 0.72 15.28 0 14.4 0C13.952 0 13.552 0.176 13.264 0.464L8 5.744L2.736 0.464C2.448 0.176 2.048 0 1.6 0C0.72 0 0 0.72 0 1.6C0 2.048 0.176 2.448 0.464 2.736L5.744 8L0.48 13.264C0.176 13.552 0 13.952 0 14.4C0 15.28 0.72 16 1.6 16C2.048 16 2.448 15.824 2.736 15.536L8 10.256L13.264 15.52C13.552 15.824 13.952 16 14.4 16C15.28 16 16 15.28 16 14.4C16 13.952 15.824 13.552 15.536 13.264L10.256 8Z"
                      fill="#6B829A"
                    />
                  </svg>
                </button>
              </div>
              <div class="giga-upload_file_name">
                <i class="extention-icon">
                  <img
                    v-if="
                      getFileExtention(documentUpload.nomDuDocument) === 'xlsx'
                    "
                    alt="xlsx.svg"
                    src="~@/assets/images/extensions/xls.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(documentUpload.nomDuDocument) === 'txt'
                    "
                    alt="txt.svg"
                    src="~@/assets/images/extensions/txt.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(documentUpload.nomDuDocument) === 'pdf'
                    "
                    alt="pdf.svg"
                    src="~@/assets/images/extensions/pdf.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(documentUpload.nomDuDocument) === 'docx'
                    "
                    alt="docx.svg"
                    src="~@/assets/images/extensions/doc.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(documentUpload.nomDuDocument) === 'doc'
                    "
                    alt="doc.svg"
                    src="~@/assets/images/extensions/doc.svg"
                  />
                  <img
                    v-else-if="
                      getFileExtention(documentUpload.nomDuDocument) === 'zip'
                    "
                    alt="zip.svg"
                    src="~@/assets/images/extensions/zip.svg"
                  />
                  <img
                    v-else
                    alt="text.svg"
                    src="~@/assets/images/extensions/text.svg"
                  /> </i
                >{{ documentUpload.nomDuDocument }}
              </div>
              <div class="giga-upload_file_type_replace">
                <span v-if="Array.isArray(selectedDocument.types)">
                  {{ selectedDocument.types.map(type => type.name).join(", ") }}
                </span>
                <span v-else>
                  {{ selectedDocument.types.name }}
                </span>
              </div>
              <div class="giga-upload_file_date">
                {{ new Date().toLocaleDateString("fr-FR") }}
              </div>
            </div>
          </div>
          <div v-if="currentStep === 2" class="giga-upload_files_list">
            <div>
              <template v-for="file in files">
                <div
                  v-if="!file.success"
                  :key="file.id"
                  class="giga-upload_file_item"
                >
                  <div class="giga-upload_file_action">
                    <button class="upload_file_delete_action">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        @click="clearFile"
                      >
                        <path
                          d="M10.256 8L15.52 2.736C15.824 2.448 16 2.048 16 1.6C16 0.72 15.28 0 14.4 0C13.952 0 13.552 0.176 13.264 0.464L8 5.744L2.736 0.464C2.448 0.176 2.048 0 1.6 0C0.72 0 0 0.72 0 1.6C0 2.048 0.176 2.448 0.464 2.736L5.744 8L0.48 13.264C0.176 13.552 0 13.952 0 14.4C0 15.28 0.72 16 1.6 16C2.048 16 2.448 15.824 2.736 15.536L8 10.256L13.264 15.52C13.552 15.824 13.952 16 14.4 16C15.28 16 16 15.28 16 14.4C16 13.952 15.824 13.552 15.536 13.264L10.256 8Z"
                          fill="#6B829A"
                        />
                      </svg>
                    </button>
                  </div>
                  <div class="giga-upload_file_name">
                    <i class="extention-icon">
                      <img
                        v-if="getFileExtention(file.name) === 'xlsx'"
                        alt="xls.svg"
                        src="~@/assets/images/extensions/xls.svg"
                      />
                      <img
                        v-else-if="getFileExtention(file.name) === 'txt'"
                        alt="txt.svg"
                        src="~@/assets/images/extensions/txt.svg"
                      />
                      <img
                        v-else-if="getFileExtention(file.name) === 'pdf'"
                        alt="pdf.svg"
                        src="~@/assets/images/extensions/pdf.svg"
                      />
                      <img
                        v-else-if="getFileExtention(file.name) === 'docx'"
                        alt="docx.svg"
                        src="~@/assets/images/extensions/doc.svg"
                      />
                      <img
                        v-else-if="getFileExtention(file.name) === 'doc'"
                        alt="doc.svg"
                        src="~@/assets/images/extensions/doc.svg"
                      />
                      <img
                        v-else-if="getFileExtention(file.name) === 'zip'"
                        alt="zip.svg"
                        src="~@/assets/images/extensions/zip.svg"
                      />
                      <img
                        v-else
                        alt="text.svg"
                        src="~@/assets/images/extensions/text.svg"
                      />
                    </i>
                    {{ file.name }}
                  </div>
                  <div class="giga-upload_file_progress progress c-progress">
                    <div
                      :class="{
                        'progress-bar': true,
                        'bg-danger': file.error,
                        'progress-bar-animated': file.active
                      }"
                      role="progressbar"
                      :style="{ width: file.progress + '%' }"
                    ></div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!files.length" class="file-upload">
        <div class="giga-file_upload" style="width: 96%">
          <div class="giga-file_upload_row">
            <div
              class="drop_files_here giga-drop-files_zone"
              :class="{
                'drop-active': $refs.upload && $refs.upload.dropActive
              }"
            >
              <div class="giga-file_upload_text">
                <i>
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_201_6190)">
                      <path
                        d="M21.2929 21.293L15.9697 15.9697L10.6465 21.293"
                        stroke="#132D48"
                        stroke-width="2.66162"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.9697 15.9697V27.947"
                        stroke="#132D48"
                        stroke-width="1.87879"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M27.1352 24.4735C28.4332 23.7658 29.4586 22.6461 30.0495 21.291C30.6404 19.9359 30.7633 18.4226 30.3986 16.9899C30.034 15.5573 29.2026 14.2868 28.0357 13.3791C26.8688 12.4714 25.4329 11.9782 23.9546 11.9772H22.2777C21.8749 10.4191 21.1241 8.97266 20.0818 7.74654C19.0395 6.52041 17.7328 5.54652 16.26 4.89809C14.7871 4.24967 13.1864 3.94357 11.5782 4.00283C9.97001 4.06208 8.39617 4.48513 6.97502 5.24019C5.55386 5.99524 4.32236 7.06265 3.37311 8.36215C2.42386 9.66166 1.78156 11.1595 1.49449 12.7429C1.20742 14.3264 1.28306 15.9543 1.71571 17.5044C2.14837 19.0544 2.92679 20.4862 3.99244 21.6921"
                        stroke="#132D48"
                        stroke-width="1.87879"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M21.2929 21.293L15.9697 15.9697L10.6465 21.293"
                        stroke="#132D48"
                        stroke-width="1.87879"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_201_6190">
                        <rect width="31.9394" height="31.9394" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </i>
                <span>Glisser-Déposer vos documents</span>
              </div>
              <div class="giga-file_upload_button giga-button">
                <label
                  class="giga-blue_button no-icon"
                  :for="'fileReplaceUploadId'"
                >
                  <span>{{ $t("add_document") }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vue-file-upload
        :input-id="'fileReplaceUploadId'"
        :post-action="postAction"
        :multiple="false"
        :extensions="extensions"
        :thread="3"
        :drop="true"
        :add-index="false"
        v-model="files"
        :auto-upload="false"
        @input-file="inputFile"
        @input-filter="inputFilter"
        ref="upload"
      >
      </vue-file-upload>
      <OperationList
        :operations="selectedDocument.operations"
        :is-selected="false"
        :is-deleted="false"
        :is-simulation="isSimulation"
      ></OperationList>
      <div class="gigwhat-model_footer mt-5">
        <div class="half-footer left-content">
          <div class="giga-button">
            <button
              id="btn-leave"
              class="giga-blue_outlined_button no-icon"
              @click="closeReplaceModal()"
            >
              {{ $t("cancel") }}
            </button>
          </div>
        </div>
        <div class="half-footer right-content">
          <div class="giga-button">
            <button
              id="btn-submit"
              class="giga-green_button no-icon mr-5"
              @click="showConfirmReplaceModel"
              :disabled="!isDisabled"
            >
              {{ $t("replace") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <confirm-modal
      id="confirm-replace"
      :content="$t('would-you-like-to-replace-the-document')"
      :modal_title="$t('confirm-replace-document')"
      :loader="false"
      fontSize="h3"
      backdrop-close="false"
      @yesClick="replaceDocument()"
      @close="hideConfirmatReplaceModal()"
    ></confirm-modal>
  </b-modal>
</template>

<script>
import OperationList from "@/components/static/AddDocument/OperationList.vue";
import { mapActions, mapGetters } from "vuex";
import { pathConstants } from "@/shared/pathConstants";
import { queryConstant } from "@/shared/queryConstant";
import ConfirmModal from "@/components/static/ConfirmModal.vue";
import { constants } from "@/shared/constants";

export default {
  name: "ReplaceDocument",
  components: { ConfirmModal, OperationList },
  data() {
    return {
      extensions: /\.[\w]+$/i,
      postAction: pathConstants.API + "/documents/draft-upload",
      files: [],
      documentUpload: {},
      isDisabled: false,
      currentStep: 1,
      customFilter: queryConstant.setDefaultCustomFilter()
    };
  },
  props: {
    modalId: {
      type: String,
      required: true
    },
    selectedDocument: {
      type: Object,
      required: true
    },
    isSimulation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters("work", ["getWorkOperations", "getWork"]),
    ...mapGetters("simulation", ["getAssignOperations", "getSimulation"])
  },
  methods: {
    ...mapActions("notification", ["closeModal"]),
    ...mapActions("document", ["replaceDocumentsAction"]),
    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    closeReplaceModal() {
      this.clearFile();
      this.closeModal({ instance: this.$root, id: this.modalId });
    },
    showConfirmReplaceModel() {
      this.$root.$emit("bv::show::modal", "confirm-replace");
    },
    inputFile(newFile, oldFile) {
      if (newFile && newFile.success) {
        this.documentUpload.id = this.selectedDocument.id;
        this.documentUpload.location = newFile.response;
        this.documentUpload.nomDuDocument = newFile.file.name;
        this.isDisabled = true;
      }
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true;
          this.currentStep = 2;
        }
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files

        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js  file
        const regexBlockedExtension = new RegExp(
          `\\.(${constants.BLOCKED_EXTENSIONS.join("|")})$`,
          "i"
        );
        if (regexBlockedExtension.test(newFile.name)) {
          return prevent();
        }
      }
      if (
        this.newFileWithoutError(oldFile) &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        newFile.blob = "";
        const URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
      }
    },
    clearFile() {
      this.files = [];
      this.currentStep = 1;
      this.documentUpload = {};
      this.isDisabled = false;
    },
    replaceDocument() {
      const id = this.isSimulation ? this.getSimulation.id : this.getWork.id;
      this.replaceDocumentsAction({
        replaceDocument: this.documentUpload,
        id: id,
        customFilter: this.customFilter
      });
      this.closeReplaceModal();
    },
    hideConfirmatReplaceModal() {
      this.$root.$emit("bv::hide::modal", "confirm-replace");
    }
  }
};
</script>

<style scoped lang="scss">
.giga-files_upload_section {
  padding: 10px 30px 10px 100px;
  border-radius: 6px;
  border: 2px solid #e0e7ee;
  width: 96%;
  background-color: #f4f6fa;
  //margin-bottom: 3%;
  .giga-files_upload_header {
    display: flex;
    flex-wrap: wrap;

    .giga-files_header_col_name {
      flex: 0 0 65%;
      max-width: 45%;
    }

    .giga-files_header_col_date {
      flex: 0 0 18%;
      max-width: 45%;
    }

    .giga-files_header_col_type {
      flex: 0 0 35%;
      max-width: 45%;
    }

    .giga-files_header_col_type_replace {
      flex: 0 0 30%;
      max-width: 45%;
    }
  }
}

.giga-upload_files_list {
  .giga-upload_file_item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .giga-upload_file_date {
      flex: 0 0 18%;
      max-width: 45%;
    }

    .giga-upload_file_type {
      flex: 0 0 35%;
      max-width: 45%;
    }

    .giga-upload_file_type_replace {
      flex: 0 0 30%;
      max-width: 45%;
    }

    .giga-upload_file_name {
      flex: 0 0 65%;
      max-width: 45%;
      font-size: 15px;
      font-weight: 600;
      color: #132d48;
      display: flex;
      align-items: center;

      .extention-icon {
        width: 40px;
        height: 40px;
        border-radius: 6px;
        background-color: #e0e7ee;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 15px;

        img {
          width: 20px;
        }
      }
    }
  }
}
</style>
